export type InitFlow = {
  campaignInfo?: CampaignInfo;
  promotionInfo?: PromotionInfo;
  correlationId?: string;
  ratingDate?: string;
  parameters?: Parameter[];
  logicModules?: LogicModule[];
};

export type CampaignInfo = {
  initialImage?: string;
  specialTariffImage?: string;
  campaignCode?: string;
  marketingId?: string;
  cooperationId?: string;
  exitIntentLayerTitle?: string;
  exitIntentLayerDescription?: string;
  unavailablePhoneDescription?: string;
  availablePhoneFrom?: string;
  availablePhoneTo?: string;
  unavailablePhoneButtonUrlTitle?: string;
  unavailablePhoneButtonUrl?: string;
  exitIntentLayerButtonText?: string;
  telephoneNumber?: string;
};

export type PromotionInfo = {
  promotionCode?: string;
  promotionWelcomeImage?: string;
  promotionSpecialImage?: string;
};

export type Parameter = {
  name?: string;
  value?: any;
};

export type LogicModule = {
  logicModuleCode?: string;
  image?: Image;
  logicModuleId?: string;
  activated?: boolean;
};

export type Image = {
  name?: string;
  url?: string;
};

export type TariffOptionDescriptionValue = {
  KaskoClever: KaskoClever;
  SCH: Sch;
  FAS: Fas;
  NPT: Npt;
  VRS: Vrs;
  FKK: Fkk;
};

export type KaskoClever = {
  overlayDescription: string;
  description: string;
  features: string[];
  percentageText: string;
  title: string;
  percentage: string;
};

export type Sch = {
  title: string;
  overlayDescription: string;
  description: string;
};

export type Fas = {
  title: string;
  overlayDescription: string;
  description: string;
};

export type Npt = {
  title: string;
  overlayDescription: string;
  description: string;
};

export type Vrs = {
  title: string;
  overlayDescription: string;
  description: string;
};

export type Fkk = {
  title: string;
  overlayDescription: string;
  description: string;
};

export type YebDates = {
  YEBPostSeasonEnd: string;
  YEBPreSeasonStart: string;
  YEBSeasonEnd: string;
  YEBSeasonStart: string;
};

export type TafData = {
  image: string;
  title: string;
  description: string;
  buttonText: string;
};
